module.exports = __webpack_public_path__ + "static/media/sorry-no-results-v2.c1f18bec.jpg";